<template>
  <b-modal id="table_settings_positions" v-model="active" title="Настройки столбцов" centered hide-footer>
    <div :class="{ 'm-table-settings-driver': isDriverTableSettings }" class="m-table-settings">
      <div class="m-table-settings__inputs">
        <div v-if="withCategories !== undefined" class="m-table-settings__input">
          <c-select
            v-model="selectedCategories"
            class="m-table-settings__input-categories"
            placeholder="Все группы"
            :items="selectCategories"
            multiple
            searchable
          />
        </div>

        <div class="m-table-settings__input">
          <c-input
            v-model="search"
            class="m-table-settings__input-search"
            placeholder="Поиск по наименованию"
            icon="search"
            placeholder-style="italic"
            clearable
          />
        </div>
      </div>

      <div class="m-table-settings__content">
        <div class="m-table-settings__results" @scroll="handleScroll">
          <div
            v-for="(column, columnIndex) in localColumns"
            :key="columnIndex"
            class="m-table-settings__column"
            :class="{
              'm-table-settings__column_show': isOpenedCategory(column.id),
              'm-table-settings__column_category': column.isCategory === 1,
            }"
          >
            <template v-if="column.isVisible">
              <div
                v-if="withGrouped && column.isVisible"
                class="m-table-settings__item"
                :class="{
                  'm-table-settings__item_parent': column.isCategory === 1,
                  'm-table-settings__item_parent_shadow': column.isCategory === 1 && scrolled,
                }"
              >
                <div class="m-table-settings__item-wrapper" @click="(e) => clickColumnCheckbox(e, column)">
                  <div
                    class="m-table-settings__item-checkbox"
                    :class="{
                      'm-table-settings__item-checkbox_check': isColumnCheck(column),
                      'm-table-settings__item-checkbox_half': isColumnHalf(column),
                    }"
                  >
                    <svg
                      class="m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_check"
                      width="11"
                      height="8"
                      viewBox="0 0 11 8"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z"
                      />
                      <path
                        d="M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z"
                      />
                    </svg>

                    <div
                      class="m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_square"
                    ></div>
                  </div>

                  <div class="m-table-settings__item-label">{{ column.label }}</div>
                </div>

                <div class="m-table-settings__item-toggle" @click="(e) => categoryToggle(e, column.id)">
                  <div class="m-table-settings__item-toggle-icon">
                    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z"
                        fill="#0066FF"
                      />
                      <path
                        d="M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z"
                        fill="#0066FF"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              <ul
                :class="{ 'm-table-settings__column-children-without-category': withGrouped !== undefined }"
                class="m-table-settings__column-children"
              >
                <li v-for="(column, columnIndex) in column.columns.filter(c=>c.isVisible)" :key="columnIndex" class="m-table-settings__column">
                  <template v-if="column.isVisible">
                    <label class="m-table-settings__item" @click="(e) => clickColumnCheckbox(e, column)">
                      <div
                        class="m-table-settings__item-checkbox"
                        :class="{
                          'm-table-settings__item-checkbox_check': isColumnCheck(column),
                          'm-table-settings__item-checkbox_half': isColumnHalf(column),
                        }"
                      >
                        <svg
                          class="m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_check"
                          width="11"
                          height="8"
                          viewBox="0 0 11 8"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z"
                          />
                          <path
                            d="M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z"
                          />
                        </svg>

                        <div
                          class="m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_square"
                        ></div>
                      </div>

                      <div class="m-table-settings__item-label">{{ column.label }}</div>
                    </label>

                    <div v-if="column.columns.length > 0" class="m-table-settings__column-children-children">
                      <div
                        v-for="(column, columnIndex) in column.columns"
                        :key="columnIndex"
                        class="m-table-settings__column"
                      >
                        <label
                          v-if="column.isVisible"
                          class="m-table-settings__item"
                          @click="(e) => clickColumnCheckbox(e, column)"
                        >
                          <div
                            class="m-table-settings__item-checkbox"
                            :class="{
                              'm-table-settings__item-checkbox_check': isColumnCheck(column),
                              'm-table-settings__item-checkbox_half': isColumnHalf(column),
                            }"
                          >
                            <svg
                              class="m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_check"
                              width="11"
                              height="8"
                              viewBox="0 0 11 8"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z"
                              />
                              <path
                                d="M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z"
                              />
                            </svg>

                            <div
                              class="m-table-settings__item-checkbox-value m-table-settings__item-checkbox-value_square"
                            ></div>
                          </div>

                          <div class="m-table-settings__item-label">{{ column.label }}</div>
                        </label>
                      </div>
                    </div>
                  </template>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>

      <div class="m-table-settings__actions">
        <c-button size="large" class="m-table-settings__actions-item" label="Сбросить" @click="reset" />
        <c-button
          class="m-table-settings__actions-item"
          :disabled="isEmptyChoiceColumns(localColumns)"
          label="Применить"
          color="blue"
          size="large"
          @click="submit"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from "@/components/controls/input";
import Button from "@/components/controls/button";
import Select from "@/components/controls/select";

export default {
  name: "m-table-settings",

  components: {
    "c-input": Input,
    "c-button": Button,
    "c-select": Select,
  },

  props: [
    "value",
    "columns",
    "withGrouped",
    "disabledColumns",
    "withCategories",
    "defaultDisabledColumns",
    "isGrouped",
    "isDriverTableSettings",
  ],

  data() {
    return {
      active: this.value,
      search: "",
      localColumns: [],
      grouped: false,
      scrolled: false,

      selectCategories: [],
      selectedCategories: [],

      disabledColumnsLocal: this.disabledColumns,

      openedCategories: [],
    };
  },

  watch: {
    columns(value) {
      let columns = value.filter(
        (item) => item.level === 0 && item.isCategory === 1 && item.characteristic !== "common",
      );

      const selectCategories = columns.map((item) => ({
        value: item.id,
        label: item.label,
      }));

      this.selectCategories = selectCategories;

      let commonColumns = value.filter((item) => item.level === 0 && item.isCategory === 0);

      columns = columns.map((item) => ({
        id: item.id,
        label: item.label,
        columns: this.getChildren(item),
        enabled: !this.disabledColumns.includes(item.id),
        isVisible: true,
        isCategory: item.isCategory,
      }));

      if (commonColumns.length > 0) {
        selectCategories.unshift({
          value: "common",
          label: "Общие",
        });

        const commonCategories = value.filter(
          (item) => item.level === 0 && item.isCategory === 1 && item.characteristic === "common",
        );

        commonColumns = commonColumns.concat(commonCategories);

        columns.unshift({
          id: "common",
          label: "Общие",
          isCategory: 1,
          isVisible: true,
          columns: commonColumns.map((item) => ({
            id: item.id,
            label: item.label,
            columns: this.getChildren(item),
            isVisible: true,
            enabled: !this.disabledColumns.includes(item.id),
            isCategory: 0,
          })),
        });
      }

      this.localColumns = columns;
    },

    selectedCategories() {
      // let columns = [];
      //
      // let commonColumns = this.columns.filter(item => item.level === 0 && item.isCategory === 0)
      //
      // if (value.length > 0) {
      //   let values = value.map(item => item.value);
      //
      //   for (let i in values) {
      //     let columnId = values[i];
      //
      //     let _columns = this.columns.filter(item => item.level === 0 && item.isCategory === 1 && columnId === item.id && item.characteristic !== "common");
      //
      //     if (columnId === 'common') {
      //       let commonCategories = this.columns.filter(item => item.level === 0 && item.isCategory === 1 && item.characteristic === "common");
      //
      //       commonColumns = commonColumns.concat(commonCategories);
      //
      //       _columns = [{
      //         id: 'common',
      //         label: 'Общие',
      //         isCategory: 1,
      //         columns: commonColumns.map(item => ({
      //           id: item.id,
      //           label: item.fullName,
      //           columns: this.getChildren(item),
      //           enabled: true,
      //           isCategory: 0,
      //         }))
      //       }]
      //     } else {
      //       _columns = _columns.map(item => ({
      //         id: item.id,
      //         label: item.fullName,
      //         columns: this.getChildren(item),
      //         enabled: true,
      //         isCategory: item.isCategory
      //       }))
      //     }
      //
      //     columns = columns.concat(_columns)
      //   }
      // } else {
      //   let _columns = this.columns.filter(item => item.level === 0 && item.isCategory === 1 && item.characteristic !== "common");
      //
      //   _columns = _columns.map(item => ({
      //     id: item.id,
      //     label: item.fullName,
      //     columns: this.getChildren(item),
      //     enabled: true,
      //     isCategory: item.isCategory
      //   }))
      //
      //   columns = columns.concat(_columns)
      //
      //   if (commonColumns.length > 0) {
      //     let commonCategories = this.columns.filter(item => item.level === 0 && item.isCategory === 1 && item.characteristic === "common");
      //
      //     commonColumns = commonColumns.concat(commonCategories);
      //
      //     columns.unshift({
      //       id: 'common',
      //       label: 'Общие',
      //       isCategory: 1,
      //       columns: commonColumns.map(item => ({
      //         id: item.id,
      //         label: item.fullName,
      //         columns: this.getChildren(item),
      //         enabled: true,
      //         isCategory: 0,
      //       }))
      //     })
      //   }
      // }
      //
      // this.localColumns = columns;
      // this.initDisabledColumns();
    },



    search(value) {
      if (value !== "") {
        this.localColumns.forEach((column) => {
          let isFindChildrenColumn = false;
          let isFindChildrenChildrenColumn = false;
          column.isVisible = false;

          column.columns.forEach((col) => {
            isFindChildrenChildrenColumn = false;
            col.isVisible = false;

            if (col.label.toLowerCase().includes(value.toLowerCase())) {
              col.isVisible = true;
              isFindChildrenColumn = true;
              col.columns.forEach((childCol) => {
                childCol.isVisible = true;
              });
            } else if (col.columns.length > 0) {
              col.columns.forEach((childCol) => {
                childCol.isVisible = false;
                if (childCol.label.toLowerCase().includes(value.toLowerCase())) {
                  childCol.isVisible = true;
                  isFindChildrenColumn = true;
                  isFindChildrenChildrenColumn = true;
                }
              });
            }

            if (isFindChildrenChildrenColumn) col.isVisible = true;
          });

          if (isFindChildrenColumn || isFindChildrenChildrenColumn) column.isVisible = true;
        });
      } else {
        this.localColumns.forEach((column) => {
          column.isVisible = true;
          column.columns.forEach((col) => {
            col.isVisible = true;
            if (col.columns.length > 0) {
              col.columns.forEach((childCol) => {
                childCol.isVisible = true;
                if (childCol.columns.length > 0) {
                  childCol.forEach((c) => {
                    c.isVisible = true;
                    if (c.columns.length > 0) {
                      c.columns.forEach((lastChild) => {
                        lastChild.isVisible = true;
                      });
                    }
                  });
                }
              });
            }
          });
        });
      }

      const tableSettingsResultsBlock = document.getElementById("table-settings-results");
      if (tableSettingsResultsBlock !== undefined && tableSettingsResultsBlock !== null) {
        tableSettingsResultsBlock.scrollTop = 0;
      }
    },

    disabledColumns(value) {
      if (value.length === this.columns.length) {
        const indexPersonalData = value.findIndex((item) => item === "personalData");
        if (indexPersonalData !== -1) value.splice(indexPersonalData, 1);
        const indexFullName = value.findIndex((item) => item === "fullName");
        if (indexFullName !== -1) value.splice(indexFullName, 1);
      } else {
        this.disabledColumnsLocal = value;
        this.initDisabledColumns();
      }
    },

    value(value) {
      if (value) {
        this.selectedCategories = [];
      }
      this.active = value;
    },

    active(value) {
      this.$emit("input", value);
    },

    isGrouped(value) {
      this.grouped = value;
    },
  },

  mounted () {
    //console.log(this.columns, this.disabledColumns)
  },

  created () {
    //console.log(this.columns, this.disabledColumns)
  },
  methods: {
    handleScroll(e) {
      this.scrolled = e.target.scrollTop > 0;
    },

    categoryToggle(e, columnId) {
      const index = this.openedCategories.findIndex((item) => item === columnId);

      if (index === -1) {
        this.openedCategories.push(columnId);
      } else {
        this.openedCategories.splice(index, 1);
      }
    },

    isOpenedCategory(columnId) {
      const index = this.openedCategories.findIndex((item) => item === columnId);

      return index !== -1;
    },

    isColumnCheck(column) {
     // console.log(column);
      if (column.columns.length > 0) {
        const total = column.columns.length;

        const enabledColums = column.columns.filter((item) => item.enabled);

        return total === enabledColums.length;
      }
      return column.enabled;
    },

    isColumnHalf(column) {
      if (column.columns.length > 0) {
        const total = column.columns.length;

        const enabledColums = column.columns.filter((item) => item.enabled);

        if (enabledColums.length === 0) {
          return false;
        }
        return total > enabledColums.length;
      }
      return false;
    },

    clickColumnCheckbox(e, column) {
      column.enabled = !column.enabled;

      Object.keys(column.columns).forEach((i) => {
        const _column = column.columns[i];

        _column.enabled = column.enabled;

        Object.keys(_column.columns).forEach((ii) => {
          const __column = _column.columns[ii];

          __column.enabled = column.enabled;
        });
      });
    },

    submit() {

      this.setDisabledColumns(this.localColumns);

      if (this.disabledColumnsLocal.length - 1 === this.columns.length) {
        console.error("Невозможно отключить все столбцы, пожалуйста выберите хотя бы один");
      } else if (this.withGrouped !== undefined) {
        this.$emit("submit", this.disabledColumnsLocal, this.grouped);
      } else {
        this.$emit("submit", this.disabledColumnsLocal);
      }

      this.active = false;
    },

    reset() {
      this.active = false;

      const columns = [];

      columns.unshift({
        id: "common",
        label: "Общие",
        isCategory: 1,
        isVisible: true,
        columns: this.columns
          .filter((item) => !item.parentColumnId)
          .map((item) => ({
            id: item.id,
            label: item.label,
            isVisible: true,
            columns: this.getColumns(item),
            enabled: true,
          })),
      });

      if (this.withGrouped !== undefined) {
        this.$emit("submit", this.defaultDisabledColumns, this.grouped);
      } else {
        this.$emit("submit", this.defaultDisabledColumns);
      }

      this.localColumns = columns;
      this.setDisabledColumns(this.defaultDisabledColumns);
      this.submit();
    },

    setDisabledColumns(columns) {
      Object.keys(columns).forEach((i) => {
        if (!columns[i].enabled) {
          const col = this.disabledColumnsLocal.find((item) => item === columns[i].id);

          if (!col) this.disabledColumnsLocal.push(columns[i].id);
        } else {
          let index = this.disabledColumnsLocal.findIndex((item) => item === columns[i].id);
          const { isCategory } = columns[i];

          if (isCategory === 1) {
            const isAllColumnsInactive = columns[i].columns.every((item) => !item.enabled);
            if (isAllColumnsInactive) {
              this.disabledColumnsLocal.push(columns[i].id);
            }
          } else {
            const parentCol = this.getParent(columns[i]);
            const parentColIndex = this.disabledColumnsLocal.findIndex((item) => item === parentCol);
            if (parentColIndex !== -1) this.disabledColumnsLocal.splice(parentColIndex, 1);

            index = this.disabledColumnsLocal.findIndex((item) => item === columns[i].id);
          }

          if (index !== -1) this.disabledColumnsLocal.splice(index, 1);
        }

        this.setDisabledColumns(columns[i].columns);
      });
    },

    getColumns(column) {
      const columns = this.columns.filter((item) => item.parentColumnId === column.id);
     // console.log(columns);
      return columns.map((item) => ({
        id: item.id,
        label: item.label,
        columns: this.getColumns(item),
        enabled: true,
      }));
    },

    getParent(column) {
      let parentColumn = false;
      this.localColumns.forEach((parentItem) => {
        const currentParent = parentItem.id;
        parentItem.columns.forEach((item) => {
          if (item.id === column.id) {
            parentColumn = currentParent;
          }
        });
      });
      return parentColumn;
    },

    getChildren(column) {
      const columns = this.columns.filter((item) => item.parentColumnId === column.id);

      return columns.map((item) => ({
        id: item.id,
        label: item.label,
        isVisible: true,
        columns: this.getChildren(item),
        enabled: true,
      }));
    },

    initDisabledColumns() {
      const value = this.disabledColumnsLocal;

      Object.keys(this.localColumns).forEach((i) => {
        this.localColumns[i].enabled = !value.includes(this.localColumns[i].id);

        Object.keys(this.localColumns[i].columns).forEach((ii) => {
          this.localColumns[i].columns[ii].enabled = !value.includes(this.localColumns[i].columns[ii].id);

          Object.keys(this.localColumns[i].columns[ii].columns).forEach((iii) => {
            this.localColumns[i].columns[ii].columns[iii].enabled = !value.includes(
              this.localColumns[i].columns[ii].columns[iii].id,
            );
          });
        });
      });
    },

    isEmptyChoiceColumns(localColumns) {
      return !localColumns.some((col) => {
        if (col.enabled && col.isCategory !== 1) {
          return true;
        }
        return col.columns.some((childCol) => {
          if (childCol.enabled && childCol.isCategory !== 1) {
            return true;
          }
          return childCol.columns.some((child) => child.enabled);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.m-table-settings {
  &__inputs {
    display: flex;
    margin: 0 -15px;

    &-group {
      margin-left: 30px;
      width: 220px;
    }

    @media screen and (max-width: 700px) {
      &-search {
        width: 100%;
      }
    }
  }

  &__input {
    width: 100%;
    padding: 0 15px;

    &__switcher {
      @media screen and (max-width: 700px) {
        margin-top: 21px;
      }
    }

    &-categories,
    &-search,
    &-group {
      width: 100%;
    }
  }

  &__content {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      height: 20px;
      width: 100%;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    }
  }

  &__results {
    margin-top: 23px;
    max-height: 400px;
    overflow-y: auto;
    padding-right: 20px;

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
    }
  }

  &__column {
    &_category {
      padding: 20px 0 10px;
      border-bottom: 1px solid $color-border-light;
      border-top: 1px solid $color-border-light;
      margin-bottom: 20px;

      @media screen and (max-width: 700px) {
        margin-bottom: 0;
        padding: 0;
      }

      & + .m-table-settings__column_category {
        border-top: none;
        padding-top: 0;
      }

      &:first-child {
        border-top: none;
      }
    }

    &:last-child {
      margin-bottom: 0;
      border-bottom: 0;
    }

    &:first-child {
      padding-top: 0;
    }

    &-children {
      margin-left: 28px;
      margin-top: 15px;
      column-count: 2;
      // column-fill: balance;
      // break-inside: avoid-column;
      // display: grid;
      // grid-auto-flow: row;
      // grid-template-columns: repeat(2, 1fr);
      // grid-auto-columns: 50%;
      // grid-auto-rows: min-content;
      // grid-auto-rows: min-content;
      // grid-template-areas: 'a a';
      // max-width: 100%;

      // height: 1000px;

      &-without-category {
        list-style-type: disc;
        -webkit-columns: 2;
        -moz-columns: 2;
        columns: 2;
        list-style-position: inside;
        list-style: none;
        padding: 0;
        margin-left: 0;
        margin-top: 0;

        & .m-table-settings__column {
          float: left;
          width: 100% !important;
        }

        @media screen and (max-width: 700px) {
          flex-wrap: nowrap;
          height: auto;
        }
      }

      .m-table-settings__column {
        width: 50%;
        padding-right: 20px;
        border-bottom: none;
        margin-bottom: 15px;
        padding-top: 0;
        page-break-inside: avoid;

        @media screen and (max-width: 700px) {
          width: 100%;
        }

        &:last-child {
          margin-bottom: 0;

          @media screen and (max-width: 700px) {
            margin-bottom: 15px;
          }
        }
      }

      &-children {
        margin-left: 28px;
        margin-top: 15px;
      }
    }
  }

  &__item {
    display: inline-flex;
    cursor: pointer;
    margin-bottom: 0;

    &-toggle {
      display: none;
    }

    &_parent {
      color: $color-label;
      font-weight: 500;

      @media screen and (max-width: 700px) {
        font-weight: 500;
        color: #000000;
      }

      @media screen and (max-width: 700px) {
        & .m-table-settings__item-label {
          font-size: 15px !important;
        }
      }
    }

    &-wrapper {
      display: flex;
      align-items: center;
    }

    &-checkbox {
      position: relative;
      border: 1px solid $color-border;
      width: 18px;
      height: 18px;
      border-radius: 3px;
      transition: 0.2s;
      flex-shrink: 0;

      &_check,
      &_half {
        border: 1px solid $color-primary;
        background: $color-primary;
      }

      &_check {
        .m-table-settings__item-checkbox-value_check {
          visibility: visible;
          opacity: 1;
        }
      }

      &_half {
        .m-table-settings__item-checkbox-value_square {
          visibility: visible;
          opacity: 1;
        }
      }

      &-value {
        position: absolute;
        top: 50%;
        left: 50%;
        transition: 0.2s;
        visibility: hidden;
        opacity: 0;

        &_check {
          margin-left: -5px;
          margin-top: -4px;
          fill: white;
        }

        &_square {
          width: 6px;
          height: 6px;
          border-radius: 1px;
          margin-top: -3px;
          margin-left: -3px;
          background: white;
        }
      }
    }

    &-label {
      font-size: 13px;
      margin-left: 10px;
    }
  }

  &__actions {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;

    @media screen and (max-width: 700px) {
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      margin: 0;
    }

    &-item {
      margin-left: 10px;

      @media screen and (max-width: 700px) {
        margin-left: 0;
        width: 50%;
        border-radius: 0;
        height: 38px;
      }
    }
  }

  @media screen and (max-width: 700px) {
    &__inputs {
      flex-direction: column;
    }

    &__input {
      width: 100%;

      &-categories {
        display: none;
      }
    }

    &__column {
      padding-top: 0;
      border-bottom: 0;

      &-children {
        margin: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        padding-top: 20px;
        transition: 0.2s;
      }

      &_hidden {
        .m-table-settings__column-children {
          height: 0 !important;
          padding-top: 0;
          margin-top: -1px;
        }

        .m-table-settings__item-toggle {
          transform: none;
        }
      }
    }

    &__results {
      margin-top: 0;
      height: calc(100vh - 187px);
      max-height: calc(100vh - 187px) !important;
      padding-right: 0;

      &::-webkit-scrollbar {
        width: 0;
        height: 100%;
      }
    }

    &__content {
      margin: 25px -20px 0;

      @media screen and (max-width: 700px) {
        margin: 0 -20px !important;
      }
    }

    &__item {
      width: 100%;
      padding: 0 20px;

      @media screen and (max-width: 700px) {
        .m-table-settings__column_show > &_parent {
          border-bottom: 0 !important;
        }

        .m-table-settings__column_show > &_parent:after {
          position: absolute;
          content: "";
          border-bottom: 1px solid $color-border-light;
          width: calc(100% - 20px);
          bottom: 0;
          right: 0;
        }

        .m-table-settings__column_show > &_parent_shadow:after {
          content: "";
          position: absolute;
          background: linear-gradient(#001550 0%, rgba(255, 255, 255, 0) 100%);
          opacity: 0.15;
          height: 10px;
          width: 100%;
          bottom: -10px;
          right: 0;
        }
        .m-table-settings__column_show + .m-table-settings__column_show > &_parent_shadow:after {
          position: absolute;
          content: "";
          height: 2px;
          width: calc(100% - 20px);
          bottom: 0;
          right: 0;
        }
      }

      &_parent {
        position: sticky;
        background: white;
        top: 0;
        padding: 15px 20px;
        border-top: 1px solid $color-border-light;
        border-bottom: 1px solid $color-border-light;
        z-index: 20;
        justify-content: space-between;
        align-items: center;
      }

      &-label {
        flex-grow: 1;
      }

      &-toggle {
        display: flex;
        width: 22px;
        height: 22px;
        border: 1px solid $color-border-light;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        transform: rotate(180deg);
        transition: 0.2s;
      }
    }
  }
}
</style>
